<template>
  <div class="liste container">
    <p class="left-align pieges">
      <i class="material-icons left">info_outline</i>Il y a 3 pièges
    </p>
    <ul>
      <li v-for="(pinard, index) of pinards" :key="index">
        <div class="card" v-scroll-reveal>
          <div class="card-image waves-effect waves-block waves-light">
            <div class="activator">
              <img class="image-vin" :src="pinard.img">
              <div class="number red lighten-3 white-text">
                <div class="inner-number">{{index+1}}</div>
              </div>
            </div>
          </div>
          <div class="card-content">
            <span class="card-title activator grey-text text-darken-4">
              <strong>{{pinard.name}}</strong>
              <!-- <i class="material-icons right">info_outline</i> -->
            </span>
          </div>
          <div class="card-reveal">
            <span class="card-title grey-text text-darken-4">
              <strong>{{pinard.name}}</strong>
              <i class="material-icons right">close</i>
            </span>
            <div class="details">
              <h6 v-if="pinard.name2">{{pinard.name2}}</h6>
              <div class="cepage">
                <svg
                  version="1.1"
                  class="grape"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  viewBox="0 0 465.107 465.107"
                  style="enable-background:new 0 0 465.107 465.107;"
                  xml:space="preserve"
                >
                  <g>
                    <path
                      d="M73.538,465.107c25.321,0,47.325-14.371,58.371-35.367c-10.941-9.787-19.094-22.565-23.175-37.083
                    c-5.422,1.195-11.03,1.87-16.802,1.87c-28.873,0-54.071-15.778-67.597-39.115c-10.38,11.656-16.745,26.954-16.745,43.756
                    C7.583,435.527,37.171,465.107,73.538,465.107z"
                    ></path>
                    <path
                      d="M30.863,341.211c0.788,1.935,1.674,3.829,2.642,5.666c11.03,21.045,33.059,35.457,58.42,35.457
                    c4.95,0,9.762-0.593,14.412-1.634c-0.35-2.999-0.577-6.04-0.577-9.128c0-9.462,1.772-18.493,4.869-26.889
                    c0.723-1.951,1.504-3.869,2.374-5.747c0.853-1.845,1.74-3.666,2.731-5.43c4.698-8.381,10.876-15.818,18.208-21.939
                    c-33.173-1.683-60.972-24.052-70.564-54.518c-22.085,10.673-37.391,33.221-37.391,59.347c0,6.544,0.992,12.859,2.772,18.834
                    C29.368,337.269,30.075,339.26,30.863,341.211z"
                    ></path>
                    <path
                      d="M169.642,324.491c-2.544-4.934-4.552-10.169-6.007-15.639c-0.024,0.008-0.041,0.016-0.065,0.024
                    c-2.032,0.658-4.024,1.414-5.966,2.26c-13.786,6.023-25.117,16.615-32.083,29.864c-0.984,1.87-1.878,3.78-2.674,5.747
                    c-0.845,2.065-1.577,4.186-2.211,6.357c-1.715,5.869-2.682,12.055-2.682,18.476c0,1.78,0.13,3.52,0.268,5.259
                    c0.171,2.13,0.447,4.219,0.813,6.283c0.358,2.024,0.813,4.016,1.357,5.966c3.008,10.9,8.714,20.687,16.412,28.556
                    c1.569,1.609,3.211,3.146,4.942,4.585c1.626,1.357,3.316,2.634,5.072,3.829c10.575,7.226,23.345,11.461,37.091,11.461
                    c36.359,0,65.939-29.58,65.939-65.947c0-1.829-0.13-3.625-0.276-5.422c-3.438,0.463-6.926,0.788-10.486,0.788
                    C208.847,366.938,182.632,349.657,169.642,324.491z"
                    ></path>
                    <path
                      d="M73.303,246.871c0.415,2.008,0.935,3.975,1.52,5.909c8.226,27.044,33.384,46.788,63.086,46.788
                    c5.926,0,11.64-0.862,17.103-2.333c1.975-0.536,3.918-1.154,5.82-1.861c0.146-0.057,0.285-0.106,0.431-0.154
                    c-0.171-2.122-0.325-4.251-0.325-6.413c0-2.731,0.146-5.43,0.423-8.096c1.935-18.696,10.51-35.432,23.296-47.869
                    c-7.909-11.096-12.989-24.313-14.184-38.643c-9.925,4.576-20.931,7.202-32.563,7.202c-17.151,0-32.986-5.625-45.886-15.038
                    c-12.347,11.99-20.053,28.726-20.053,47.26c0,2.439,0.154,4.837,0.415,7.21C72.603,242.872,72.896,244.896,73.303,246.871z"
                    ></path>
                    <path
                      d="M259.325,351.535c12.242-3.967,22.931-11.404,30.88-21.175
                    c-17.159-14.347-28.109-35.888-28.109-59.948c0-2.016,0.154-3.999,0.301-5.983c-4.593,0.845-9.299,1.349-14.127,1.349
                    c-12.908,0-25.069-3.203-35.806-8.763c-1.87-0.967-3.674-2.032-5.454-3.138c-1.837-1.146-3.617-2.374-5.349-3.666
                    c-3.268-2.439-6.365-5.08-9.21-7.99c-11.933,11.941-19.322,28.417-19.322,46.593c0,0.154,0.024,0.309,0.024,0.463
                    c0.008,1.674,0.114,3.316,0.252,4.958c0.057,0.65,0.089,1.301,0.163,1.943c0.154,1.382,0.39,2.739,0.626,4.097
                    c0.138,0.772,0.244,1.544,0.406,2.309c0.26,1.236,0.61,2.439,0.943,3.65c7.665,27.922,33.213,48.528,63.533,48.528
                    c2.837,0,5.609-0.244,8.356-0.593c2.04-0.26,4.056-0.593,6.031-1.04C255.448,352.673,257.407,352.152,259.325,351.535z"
                    ></path>
                    <path
                      d="M96.648,174.624c1.691,1.357,3.447,2.634,5.267,3.82c10.364,6.787,22.719,10.762,35.993,10.762
                    c11.86,0,22.963-3.186,32.587-8.689c0.122-1.301,0.317-2.569,0.504-3.845c0.309-2.178,0.675-4.324,1.162-6.438
                    c0.463-2.016,0.943-4.024,1.561-5.983c5.259-16.729,16.021-31.019,30.124-40.814c0-0.057,0.008-0.114,0.008-0.179
                    c0-36.359-29.588-65.939-65.947-65.939s-65.939,29.58-65.939,65.939c0,18.525,7.706,35.27,20.053,47.26
                    C93.494,171.958,95.038,173.332,96.648,174.624z"
                    ></path>
                    <path
                      d="M184.949,169.398c-0.154,0.553-0.285,1.114-0.431,1.666c-0.561,2.146-1.008,4.333-1.349,6.552
                    c-0.098,0.626-0.211,1.244-0.285,1.87c-0.228,1.861-0.358,3.747-0.431,5.657c-0.033,0.772-0.114,1.536-0.114,2.325
                    c0,0.057-0.008,0.122-0.008,0.179c0,13.892,4.341,26.776,11.713,37.416c1.154,1.666,2.365,3.276,3.658,4.82
                    c1.317,1.577,2.699,3.089,4.154,4.536c0.602,0.593,1.252,1.13,1.878,1.707c1.861,1.707,3.804,3.308,5.853,4.796
                    c1.805,1.317,3.674,2.536,5.609,3.666c9.738,5.682,21.02,8.99,33.083,8.99c5.617,0,11.039-0.78,16.249-2.105
                    c1.731-6.917,4.349-13.477,7.787-19.533c1.008-1.772,2.04-3.536,3.178-5.227c1.138-1.683,2.382-3.284,3.65-4.877
                    c8.868-11.136,20.712-19.752,34.319-24.743c0.447-3.097,0.756-6.243,0.756-9.462c0-17.631-6.999-33.636-18.314-45.479
                    c0.821-2.081,1.609-4.17,2.512-6.186c0.862-1.935,1.829-3.788,2.764-5.666c23.979-48.194,70.767-77.059,120.018-97.632
                    c19.053-7.958,10.697-39.432-8.641-31.352C354.389,25.619,302.309,58.467,273.42,113.733c-0.935,1.788-1.788,3.658-2.674,5.487
                    c-0.886,1.845-1.837,3.625-2.674,5.519c-6.251-1.975-12.9-3.048-19.801-3.048c-11.851,0-22.955,3.186-32.579,8.689
                    c-2.349,1.341-4.593,2.845-6.755,4.454c-2.731,2.04-5.324,4.243-7.698,6.665C193.679,149.214,188.021,158.757,184.949,169.398z"
                    ></path>
                    <path
                      d="M297.066,320.15c1.553,1.349,3.17,2.617,4.845,3.82c1.642,1.179,3.341,2.276,5.088,3.3
                    c9.771,5.739,21.11,9.08,33.238,9.08c36.359,0,65.939-29.58,65.939-65.939c0-36.367-29.588-65.947-65.939-65.947
                    c-5.617,0-11.039,0.78-16.249,2.105c-2.325,0.593-4.609,1.309-6.828,2.138c-2.65,0.992-5.243,2.113-7.722,3.43
                    c-7.852,4.17-14.77,9.868-20.346,16.712c-1.276,1.569-2.495,3.195-3.625,4.877c-1.154,1.723-2.243,3.503-3.235,5.332
                    c-1.195,2.203-2.227,4.495-3.17,6.844c-1.049,2.601-1.894,5.292-2.609,8.039c-0.593,2.292-1.057,4.617-1.406,6.999
                    c-0.447,3.097-0.756,6.243-0.756,9.462C274.29,290.261,283.15,308.047,297.066,320.15z"
                    ></path>
                    <path
                      d="M457.516,174.153c0,0-50.422-148.257-110.557-74.807
                    C286.816,172.795,415.516,202.603,457.516,174.153z"
                    ></path>
                  </g>
                </svg>
                <h6 v-html="pinard.cepage"></h6>
              </div>
              <div class="country-wrap">
                <h6>{{pinard.annee}}</h6>
                <img class="flag" :src="`/flags/${pinard.pays}.svg`" alt>
                <span class="canton" v-if="pinard.canton">{{pinard.canton}}</span>
              </div>
              <p v-if="pinard.description">{{pinard.description}}</p>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import store from '@/store';

export default {
  name: 'Liste',
  computed: {
    pinards() {
      return store.state.pinards;
    },
  },
};
</script>

<style lang="scss" scoped>
.pieges {
  margin-bottom: 20px;
}
.liste .card {
  min-height: 350px;
  .card-content {
    padding: 0px 24px 24px 24px;
  }
  .card-image .activator {
    padding: 24px;
  }
}
.liste .image-vin {
  height: 260px;
  display: inline-block;
  margin: 10px 0 0 0;
  width: auto;
}
.flag {
  width: 30px;
  margin: 10px;
}
.cepage {
  display: flex;
  align-items: center;
  padding-top: 10px;
  padding-bottom: 10px;
  svg {
    margin-right: 15px;
    height: 25px;
    width: 25px;
  }
  h6 {
    width: calc(100% - 40px);
    margin: 0;
    line-height: 130%;
  }
}
.country-wrap {
  border-top: 1px solid #eeeeee;
  border-bottom: 1px solid #eeeeee;
  margin-top: 5px;
  display: flex;
  align-items: center;
  h6 {
    margin: 0;
  }
}
.liste .card-reveal .card-title {
  text-align: left;
}
.liste .card-reveal .details {
  text-align: left;
}
.number {
  position: absolute;
  pointer-events: none;
  top: 24px;
  left: 24px;
  font-size: 35px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
}
</style>
